'use strict';

import tagsTemplate from './tags.directive.html';

export default angular
  .module('maestro.directives.components.tags', [])

  // todo migrate to component
  .directive('tags', function(
      $q,
      $compile,
      $filter,
      $timeout,
      utils,
      TagsService,
      I18nService
    ) {
    const $t = $filter('translate');
    return {
      restrict: 'E',
      template: tagsTemplate,
      replace: true,
      scope: {
        tagOrgId: '=', // Organization ID device's location linked to
        currentOrgId: '=', // Currently selected Organization ID
        tagId: '=', // ID of the user/device/location tag binded to
        tagType: '@', // 1 - user, 2 - location, 3 - device
        tags: '=', // Array<{}>
        ngDisabled: '=',
        hideHint: '=', // Hide help message
        addTagsSuccess: '&',
        highlights: '=?' // Array of location highlights
      },
      controller: ($scope, $element) => {
        $scope.locale = I18nService.getLocale();

        const ORGANIZATIONS_LOCAL_STORAGE_KEY = 'Organizations-All';
        const allOrganizations = utils.getStorageItem(ORGANIZATIONS_LOCAL_STORAGE_KEY);

        $scope.errorMsgs = [];
        $scope.selectedTagsKeys = [];
        $scope.deleteTag = deleteTag;
        $scope.addTags = addTags;

        init();

        $scope.$watchCollection('tags', groupTags);
        $scope.$watchCollection('selectedTagsKeys', function() {
          validTags();
        });

        /**
         * Init controller
         */
        function init() {
          getPopularTags();
        }

        /**
         * Split tags into groups:
         *  - Organisation tags;
         *  - Composer (bot-driven) tags;
         *  - User tags;
         */
        function groupTags(tags) {
          $scope.groupedTags = {
            organization: [], // Tags applied by org. admins
            composer: [], // Composer tags (tags with appId field)
            user: [] // User tags
          };

          if (!tags) {
            return;
          }

          tags.forEach(tag => {
            if (tag.appId) {
              $scope.groupedTags.composer.push(tag);
            } else if (tag.organizationId) {
              if (availableOrgs(tag)) {
                $scope.groupedTags.organization.push(tag);
              }
            } else {
              $scope.groupedTags.user.push(tag);
            }
          });
        }

        /**
         * Validate tag
         * @param {string} tag
         * @returns {string} Localized validation message (or js-falsy value if tag is valid)
         */
        function validateTag(tag) {
          if (tag.length > 18) {
            return $t('prompt.tags.invalid-tag-max-length', { tag: tag, length: 18 });
          }
          if (!$.fn.form.settings.rules.regExp(tag, '/^[A-Za-z0-9.\u4e00-\u9fa5_\-]{1,18}$/')) {
            return $t('prompt.tags.invalid-tag-regExp', { tag: tag });
          }
        }

        /**
         * Validate $scope.selectedTagsKeys collection and place errors to $scope.errorMsgs
         * @returns {boolean}
         */
        function validTags() {
          if (!$scope.selectedTagsKeys) {
            return false;
          }
          $scope.errorMsgs = [];
          for (let val of $scope.selectedTagsKeys) {
            let message = validateTag(val);
            if (message) {
              $scope.errorMsgs.push({ tag: val, message: message });
            }
          }
          return $scope.errorMsgs.length === 0;
        }

        function getPopularTags() {
          return TagsService.getPopularTags($scope.currentOrgId || $scope.tagOrgId, $scope.tagType)
            .then(data => $scope.popularTags = data.tags, err => $q.reject(err));
        }

        /**
         * Check if tag's organization available
         * @param {Object} tag
         */
        function availableOrgs(tag) {
          if (tag.organizationId === $scope.tagOrgId) {
            return true;
          }
          return allOrganizations.some(el => tag.organizationId === el.id);
        }

        function addTags() {
          if (!validTags()) {
            return;
          }
          if (!$scope.selectedTagsKeys || $scope.selectedTagsKeys.length === 0) {
            return;
          }
          let tags = [];
          for (let tagName of $scope.selectedTagsKeys) {
            tags.push({ type: parseInt($scope.tagType), id: $scope.tagId, tag: tagName });
          }
          TagsService.saveTags($scope.tagOrgId, tags)
            .then(data => {
              $scope.tags = $scope.tags || [];
              tags.forEach(newTag => {
                $scope.tags.push({
                  ...newTag,
                  organizationId: $scope.tagOrgId || newTag.organizationId
                });
              });

              $scope.$emit('addTagsCompleteEvent', data);
              $timeout(function() {
                let items = angular.copy($scope.selectedTagsKeys);
                let dropdownTags = $($element).find('#dropdown-tags');
                dropdownTags.dropdown('set value', null);
                dropdownTags.dropdown('remove selected', items);
              }, 0);
            }, err => $q.reject(err));
        }

        function deleteTag(tag) {
          return TagsService.deleteTags($scope.tagOrgId, $scope.tagType, $scope.tagId, tag.tag, tag.appId)
            .then(data => {
              let index = $scope.tags.findIndex(t => angular.equals(t, tag));
              if (index !== -1) {
                $scope.tags.splice(index, 1);
              }
              $scope.$emit('deleteTagsCompleteEvent', data);
            });
        }
      },
    };
  })

  .name;
